module.exports = __webpack_public_path__ + "66b48fa055e902310758523fe42b83c5.svg";